import type { Deal } from '@/types'
import { isDirectProposalLeadConvert } from './DealDetailPanel/meetingTypeOptions'
import {
  dealHasScheduledMeeting,
  getMeetingTiming,
} from './DealDetailPanel/reuniaoMeetingUtils'
import { dealHasSavedProposalDraft } from './dealsJourney.util'

/** Janela em que a reunião de apresentação exige proposta montada. */
export const DIRECT_PROPOSAL_MEETING_WARN_HOURS = 72
export const DIRECT_PROPOSAL_MEETING_CRITICAL_HOURS = 24

export type DirectProposalPendingAlert = {
  label: string
  tone: 'warning' | 'danger'
}

export function isDirectProposalMeetingFlow(deal: Deal): boolean {
  if (deal.etapa !== 'proposta_elaboracao' || !dealHasScheduledMeeting(deal)) return false
  const tipo = deal.reunioes?.[0]?.tipo ?? ''
  return isDirectProposalLeadConvert(tipo)
}

export function getDirectProposalPendingAlert(deal: Deal): DirectProposalPendingAlert | null {
  if (!isDirectProposalMeetingFlow(deal) || dealHasSavedProposalDraft(deal)) return null

  const raw = deal.reunioes?.[0]?.data ?? deal.dataReuniao
  if (!raw) return null

  const meetingDate = new Date(raw)
  if (Number.isNaN(meetingDate.getTime())) return null

  const hoursUntil = (meetingDate.getTime() - Date.now()) / (1000 * 60 * 60)
  const timingLabel = getMeetingTiming(raw)?.label

  if (hoursUntil < 0) {
    return {
      label: 'Reunião passou — proposta pendente',
      tone: 'danger',
    }
  }
  if (hoursUntil <= DIRECT_PROPOSAL_MEETING_CRITICAL_HOURS) {
    return {
      label: timingLabel
        ? `Proposta pendente — ${timingLabel}`
        : 'Proposta pendente — reunião em breve',
      tone: 'danger',
    }
  }
  if (hoursUntil <= DIRECT_PROPOSAL_MEETING_WARN_HOURS) {
    return {
      label: timingLabel
        ? `Montar proposta — ${timingLabel}`
        : 'Montar proposta — reunião próxima',
      tone: 'warning',
    }
  }

  return null
}

export function dealCountsAsDirectProposalJourneyRisk(deal: Deal): boolean {
  return getDirectProposalPendingAlert(deal) !== null
}
